import { isAndroidHezi, isIOSHezi } from '@remote/utils/platform'
import androidBridge from './android'
import iOSBridge from './ios'

const native = isAndroidHezi ? androidBridge : isIOSHezi ? iOSBridge : undefined

export function closeActivity () {
  if (isIOSHezi) {
    const $native = window.WebViewJavascriptBridge
    $native.callHandler('xlCloseView')
    return true
  } else if (isAndroidHezi) {
    const $native = window.HeZi
    $native.finish()
    return true
  } else {
    console.error('请在迅雷盒子客户端下操作')
    return false
  }
}

export interface ICallByJsonParams {
  router: string
  params: { [key: string]: any }
}


export function callByJson (params: ICallByJsonParams) {
  if (isAndroidHezi) {
    androidBridge.callHandler('callByJson', JSON.stringify(params))
    return true
  } else if (isIOSHezi) {
    console.error('IOS迅雷盒子客户端不支持此操作')
  } else {
    console.error('请在迅雷盒子客户端下操作')
    return false
  }
}

export function registerEventHandle (eventId: 'event_on_back_pressed', callback: () => boolean) {
  if (isAndroidHezi) {
    androidBridge.callHandler('registerEventHandle', eventId, callback)
    return () => androidBridge.callHandler('registerEventHandle', eventId)
  } else if (isIOSHezi) {
    console.error('IOS迅雷盒子客户端不支持此操作')
    return false
  } else {
    console.error('请在迅雷盒子客户端下操作')
    return false
  }
}

export function removeEventHandle (eventId: 'event_on_back_pressed') {
  if (isAndroidHezi) {
    androidBridge.callHandler('registerEventHandle', eventId, function () {
      return false
    })
    return true
  } else if (isIOSHezi) {
    console.error('IOS迅雷盒子客户端不支持此操作')
    return false
  } else {
    console.error('请在迅雷盒子客户端下操作')
    return false
  }
}

type TAndroidBridge = typeof androidBridge
type TIOSBridge = typeof iOSBridge
export type { TAndroidBridge, TIOSBridge }
export { androidBridge, iOSBridge }
export default native
